<div class="loader-overlay" *ngIf="isLoading">
  <div class="loader">
    <div class="spinner"></div>
    <p>Loading...</p>
  </div>
</div>

